import {
  HTTP_COPYMONTHBUDGET_FETCHING,
  HTTP_COPYMONTHBUDGET_SUCCESS,
  HTTP_COPYMONTHBUDGET_FAILED,
  HTTP_RESET_COPYMONTHBUDGET,
} from "src/Constants";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_COPYMONTHBUDGET_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case HTTP_COPYMONTHBUDGET_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_COPYMONTHBUDGET_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    default:
      return state;
  }
};
